// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"5f1a0c54","5999":"a0a60594","9220":"a0a60594","9329":"6140f0e0","9768":"883a956c","9859":"3beae06c"}[chunkId] + ".chunk.css";
};